import React, { useState, useRef } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import SessionScheduleManager from "../../../SessionScheduleManager/SessionScheduleManager";
import useDataSessions from '../../../../dataHooks/useDataSessions';

export default ({
  sessions = [],
  eventId,
  onClose,
  onSuccess,
}) => {
  const {
    newSessions,
    updateSessions,
    deleteSessions
  } = useDataSessions();

  const [isBusy, setIsBusy] = useState(false);

  const sessionScheduleManagerRef = useRef()

  const onClickSubmit = async () => {
    if (!isBusy) {
      setIsBusy(true)

      const modifiedSessions = sessionScheduleManagerRef.current.getModifiedSessions();
      if (modifiedSessions.length > 0) {
        await updateSessions(modifiedSessions)
      }

      const deletedSessions = sessionScheduleManagerRef.current.getDeletedSessions();
      if (deletedSessions.length > 0) {
        await deleteSessions(deletedSessions)
      }

      const newSessionsData = sessionScheduleManagerRef.current.getNewSessions();
      if (newSessionsData.length > 0) {
        await newSessions(newSessionsData)
      }

      window.dispatchEvent(new CustomEvent('reloadSessions', {}));

      setIsBusy(false)
      onSuccess()
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Confirm'}
      </Button>
    </div>
  )

  return (
    <Modal title='Edit Schedule' isFullScreen={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px',
        height: '100%',
        position: 'relative'
      }}>
        <SessionScheduleManager
          ref={sessionScheduleManagerRef}
          sessions={sessions}
          eventId={eventId}
        />
      </div>
    </Modal>
  )
}